export const WORKOUT_CATEGORIES = ["Hipertrofia", "Emagrecimento", "Iniciante", "Condicionamento", "Força", "Feminino", "Terceira Idade", "Outros"];

export const allCategories = (templates = []) => {
  const extra = templates.map(t => t.category).filter(c => c && !WORKOUT_CATEGORIES.includes(c));
  return [...WORKOUT_CATEGORIES.slice(0, -1), ...Array.from(new Set(extra)).sort(), "Outros"];
};
